import { createIdentifierStruct } from "@/modules/api/utils/jsonApiStructs";

import { tutorialResourceType } from "./tutorialResourceConsts";

export const tutorialIdentifierStruct = createIdentifierStruct(
  tutorialResourceType
);
